import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash-es';

@Component({
    selector: 'recap-applicant-details',
    templateUrl: './recap-applicant-details.component.html',
    styleUrls: ['./recap-applicant-details.component.scss'],
    standalone: false
})
export class RecapApplicantDetailsComponent {
    /**
     * Perform address matching on applicants
     *
     * @type {boolean}
     * @memberof RecapComponent
     */
    @Input() doAddressMatch: boolean = false;

    /**
     * The applicants to be displayed
     * @type Array<Object>
     * @memberof RecapApplicantDetailsComponent
     */
    @Input() applicantDetails: Array<Object>;
    /**
     * Flag to togle displaying the edit button
     *
     * @type {boolean}
     * @memberof RecapApplicantDetailsComponent
     */
    @Input() showEditButton: boolean;

    /**     *
     * flag to indicate if address match already done or not
     * @type {boolean}
     * @memberof RecapApplicantComponent
     */
    @Input() addressMatchDoneAlready: boolean = false;

    /**
     * Event emitted to tell the parent to invoke the edit action
     *
     * @type {EventEmitter<string>}
     * @memberof RecapApplicantDetailsComponent
     */
    @Output() stageChange: EventEmitter<string>;

    /**
     * Outputs the applicant details up to the recap component.
     *
     * @type {EventEmitter<FormGroup>}
     * @memberof RecapApplicantDetailsComponent
     */
    @Output() outputApplicant: EventEmitter<UntypedFormArray> = new EventEmitter<UntypedFormArray>();

    /**
     * The applicant details array (all applicants grouped together.)
     *
     * @type {FormArray}
     * @memberof RecapApplicantDetailsComponent
     */
    applicantDetailsForm: UntypedFormArray = new UntypedFormArray([
        new UntypedFormGroup({}), // Default iter 0 as a valid item, otherwise angular inputs at 0 for 1.
    ]);

    /*
     * Is this a company application
     *
     * @readonly
     * @type {string}
     * @memberof RecapApplicantDetailsComponent
     */
    get IsCompanyApplication(): string {
        if (_.isEmpty(this.applicantDetails)) {
            return;
        }

        return _.defaultTo(this.applicantDetails['IsCompanyApplication'], 'No');
    }
    /**
     * The applicants
     *
     * @readonly
     * @type {Array<Object>}
     * @memberof RecapApplicantDetailsComponent
     */
    get Applicants(): Array<Object> {
        if (_.isEmpty(this.applicantDetails)) {
            return;
        }

        return _.defaultTo(this.applicantDetails['Applicants'], null);
    }

    /**
     * Passes on message to applicant details.
     *
     * @param {any} form
     * @memberof RecapApplicantDetailsComponent
     */
    receiveApplicant(form) {
        const iter = form.get('applicantIterator').value;
        this.applicantDetailsForm.setControl(iter, form);
        this.outputApplicant.emit(this.applicantDetailsForm);
    }

    /**
     * Creates an instance of RecapApplicantDetailsComponent.
     * @memberof RecapApplicantDetailsComponent
     */
    constructor() {
        this.stageChange = new EventEmitter<string>();
    }

    /**
     * emit stage change when edit button clicked
     *
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_applicant_details');
    }
}
